<div class="avatar avatar-circle" [style.height]="height" [style.width]="width"
      [style.cursor]="showPointer ? 'pointer' : 'unset'"
>
  <ng-content></ng-content>

  <span class=" avatar-text" *ngIf="label; else iconTemplate"
      [style.font-size]="fontSize ? fontSize: null"
  >{{ label }}</span>
  <ng-template #iconTemplate>
  <span [class]="icon" [ngClass]="'avatar-icon'" *ngIf="icon; else imageTemplate">
  </span>
  </ng-template>
  <ng-template #imageTemplate>
    <img alt="avatar" [src]="image" *ngIf="image" (error)="imageError($event)"
         [attr.aria-label]="ariaLabel" />
  </ng-template>


</div>
